import '@/geolocation/screens/styles/index.scss';

import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import GeolocationModalContent from '@/geolocation/screens/GeolocationModalContent';
import { useEmbeddedLobbyGeolocation } from '@/geolocation/use-embedded-lobby-geolocation';
import { useGeolocation } from '@/geolocation/use-geolocation';
import { isEmbeddedInLobby } from '@/logic/embedded-mode';
import { setGameWindowContext } from '@/store/actions';
import { useStore } from '@/store/useStore';

import { FooterNote, LocationNote } from './GeolocationHelperNotes';

const BrowserGeolocationEffects = () => {
  useGeolocation();
  return null;
};

const EmbeddedLobbyGeolocationEffects = () => {
  useEmbeddedLobbyGeolocation();
  return null;
};

const GeolocationWrapper = ({ children }) => {
  const { geolocationFailed, geolocationRejected } = useStore(
    useShallow((s) => ({
      geolocationFailed: s.geolocationStatus.geolocationFailed,
      geolocationRejected: s.geolocationStatus.geolocationRejected,
      previouslyVerified: s.geolocationStatus.previouslyVerified,
    })),
  );

  const isLocationError = geolocationFailed || geolocationRejected;
  const geolocationEffects = isEmbeddedInLobby() ? (
    <EmbeddedLobbyGeolocationEffects />
  ) : (
    <BrowserGeolocationEffects />
  );

  useEffect(() => {
    if (isLocationError) {
      setGameWindowContext({ gameWindowOpen: false });
    }
  }, [isLocationError]);

  if (isLocationError) {
    return (
      <>
        {geolocationEffects}
        <div className="slot geolocation__container">
          <div className="modal">
            <div className="modal__content">
              <GeolocationModalContent />
            </div>
          </div>
          <div className="bottom-container">
            <LocationNote />
            <FooterNote />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {geolocationEffects}
      {children}
    </>
  );
};

export default GeolocationWrapper;
